import type { LocalePack } from './types.js';

/** Spanish (Español) — also selected via the `sp` alias. */
export const es: LocalePack = {
  headerTitle: 'Editor de fotos',
  headerSubtitle: 'Edita tu imagen con facilidad',
  applyButton: 'Aplicar',
  cancelButton: 'Cerrar',
  undo: 'Deshacer',
  redo: 'Rehacer',
  fullscreen: 'Pantalla completa',
  fit: 'Ajustar',
  zoomTooltip: 'Zoom · +/− · 0 ajustar · 1 100 %',

  emptyStateTitle: 'Suelta una imagen o haz clic para subir',
  emptyStateSubtitle: 'Compatible con: PNG, JPEG, HEIC',

  calloutLabelText: 'Etiqueta',

  tool: {
    select: 'Seleccionar',
    crop: 'Recortar',
    draw: 'Dibujar',
    eraser: 'Borrador',
    text: 'Texto',
    shapes: 'Formas',
    callout: 'Nota',
    filters: 'Filtros',
    adjust: 'Ajustar',
    move: 'Mover',
    pen: 'Lápiz',
    zoom: 'Zoom',
    zoomIn: 'Acercar',
    zoomOut: 'Alejar',
    rotateLeft: 'Girar a la izquierda',
    rotateRight: 'Girar a la derecha',
    flipH: 'Voltear H',
    flipV: 'Voltear V',
    reset: 'Restablecer',
  },

  shape: {
    circle: 'Círculo',
    ellipse: 'Elipse',
    square: 'Cuadrado',
    rectangle: 'Rectángulo',
    arrow: 'Flecha',
    polyline: 'Trazo',
  },

  filter: {
    none: 'Original',
    grayscale: 'B/N',
    sepia: 'Sepia',
    vintage: 'Vintage',
    cool: 'Frío',
    warm: 'Cálido',
    invert: 'Invertir',
  },

  props: {
    title: {
      draw: 'Dibujar',
      eraser: 'Borrador',
      text: 'Texto',
      crop: 'Recortar',
      shapes: 'Formas',
      callout: 'Nota',
      filters: 'Filtros',
      adjust: 'Ajustar',
      move: 'Mover',
    },
    aspectRatio: 'Relación de aspecto',
    applyCrop: 'Aplicar recorte',
    cancel: 'Cancelar',
    shape: 'Forma',
    preset: 'Preajuste',
    resetEffects: 'Restablecer efectos',
    resetAdjustments: 'Restablecer ajustes',
    deleteSelected: 'Eliminar selección',
    colors: 'Colores',
    recent: 'Recientes',
    customColor: 'Color personalizado',
    brushSize: 'Tamaño del pincel',
    strokeWidth: 'Grosor del trazo',
    opacity: 'Opacidad',
    eraserSize: 'Tamaño del borrador',
    fontSize: 'Tamaño de fuente',
    brightness: 'Brillo',
    contrast: 'Contraste',
    saturation: 'Saturación',
    blur: 'Desenfoque',
    quickActions: 'Acciones rápidas',
    hintMove:
      'Arrastra para mover · pellizca o desliza para hacer zoom · elige una herramienta para empezar.',
    hintEraser: 'Toca o arrastra sobre una anotación para eliminarla.',
  },
};
